import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { API } from "@/AuthContext";
import { useI18n } from "@/i18n";
import { RecipeCard } from "@/pages/Home";

export default function Recipes() {
  const { t, lang } = useI18n();
  const [recipes, setRecipes] = useState([]);
  const [filter, setFilter] = useState("all");
  const [sp] = useSearchParams();
  const city = sp.get("city");

  useEffect(() => {
    axios.get(`${API}/recipes`).then(r => setRecipes(r.data));
  }, []);

  let list = recipes;
  if (filter !== "all") list = list.filter(r => r.type === filter);
  if (city) list = list.filter(r => r.capital_city === city);

  return (
    <main className="max-w-7xl mx-auto px-6 lg:px-10 py-20" data-testid="recipes-page">
      <div className="overline">{t("catalog_overline")}</div>
      <h1 className="font-serif text-5xl lg:text-6xl tracking-tighter mt-3">{t("catalog_title")}</h1>
      {city && <p className="text-zinc-400 mt-3">{t("by")} {city}</p>}
      <div className="divider-gold my-10" />
      <div className="flex gap-3 mb-10" data-testid="filter-bar">
        {["all","meal","dessert"].map(f => (
          <button
            key={f}
            onClick={() => setFilter(f)}
            className={`tag ${filter===f?"tag-gold":""} cursor-pointer`}
            data-testid={`filter-${f}`}
          >
            {f === "all" ? t("filter_all") : f === "meal" ? t("filter_meals") : t("filter_desserts")}
          </button>
        ))}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 stagger">
        {list.map(r => <RecipeCard key={r.id} r={r} lang={lang} t={t} />)}
      </div>
      {list.length === 0 && <div className="text-zinc-500 py-16 text-center">No recipes match this filter.</div>}
    </main>
  );
}
